import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = { click: { 'toggle': 'toggle', } };
        this.forms = [...this.el.querySelectorAll( '[data-module-ajax-form]' )];
        this.forms.forEach( form => form.addEventListener( 'response', this.onResponse.bind( this ) ) );
    }
    toggle( ev ){
        let currentToggle = ev.currentTarget;
        this.$( 'item' ).forEach( item => {
            if( item.querySelector( '[data-accordion="toggle"]' ) === currentToggle ){
                item.classList.toggle( 'active' );
            } else {
                item.classList.remove( 'active' );
            }
        });
        this.call( 'update', false, 'Scroll' );
    }

    onResponse( e ){
        if( e.detail && e.detail.success === true ){
            e.currentTarget.closest( '[data-accordion="item"]').classList.remove( 'active' );
        }
    }
}
